import script from "./EducationModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationModel.vue?vue&type=script&lang=ts&setup=true"

import "./EducationModel.vue?vue&type=style&index=0&id=39a944fb&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39a944fb"]])

export default __exports__